
































































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconSearch from "@/common/components/icons/IconSearch.vue";
import InputText from "@/common/components/atoms/InputText.vue";
import SuggestPanel from "@/common/components/molecules/SuggestPanel.vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    IconBase,
    IconSearch,
    InputText,
    SuggestPanel
  }
})
export default class FormSearch extends Vue {
  @Prop({ type: String, default: "" }) search!: string;
  @Prop({ type: String, default: "メンバーを探す" }) placeholder!: string;
  @Prop({ type: String, default: "" }) suggestType!: string;

  emitSearchMember() {
    this.$emit("search-member", {});
  }

  submit() {
    this.$emit("do-search");
  }

  get internalSearch() {
    return this.search;
  }

  set internalSearch(newValue: string) {
    if (this.search !== newValue) this.$emit("update:search", newValue);
  }
}
